import { remoteInvoke } from "@quatico/magellan-client";
// @service({"namespace": "quaweb-noauth"})
export const getAppointmentSlots = async (input, _context, _serialization) => {
    return remoteInvoke({ name: "getAppointmentSlots", data: { input: input }, namespace: "quaweb-noauth" }, _context, _serialization);
};
//# sourceMappingURL=get-appointment-slots.js.map